import {
  PasswordInputProps as MantinePasswordInputProps,
  PasswordInput as MantinePasswordInput,
} from '@mantine/core';

export type PasswordInputProps = MantinePasswordInputProps;

export const PasswordInput = MantinePasswordInput;

PasswordInput.displayName = 'PasswordInput';
